module.exports = __webpack_public_path__ + "media/img/pages/companies/umb-b32b7e0195d9ce18b142ee12fd3983f6.png";